"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maskedString = exports.getNormalizedRegularHours = exports.getDistance = exports.getBg = void 0;

var _luxon = require("luxon");

var _uiKit = require("@dbi-tools/ui-kit");

var _const = require("./const");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n        color: ", ";\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n        color: ", ";\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getBg = function getBg(theme) {
  switch (theme) {
    case _const.StoreLocatorThemeVariants.SEASHELL:
    case _const.StoreLocatorThemeVariants.SEASHELL_ALT:
      return (0, _uiKit.css)(_templateObject(), _uiKit.Colors.secondaryLight);

    case _const.StoreLocatorThemeVariants.MOCASSIN:
    case _const.StoreLocatorThemeVariants.MOCASSIN_ALT:
      return (0, _uiKit.css)(_templateObject2(), _uiKit.Colors.secondary);

    case _const.StoreLocatorThemeVariants.CLARET:
      return (0, _uiKit.css)(_templateObject3(), _uiKit.Colors.wine, _uiKit.Colors.white);

    case _const.StoreLocatorThemeVariants.BLACK:
      return (0, _uiKit.css)(_templateObject4(), _uiKit.Colors.gray800, _uiKit.Colors.white);

    default:
      return (0, _uiKit.css)(_templateObject5(), _uiKit.Colors.white);
  }
}; // the most faster way to find the distance between two location in miles.
// @ts-ignore


exports.getBg = getBg;

var getDistance = function getDistance(_ref) {
  var currentLocation = _ref.currentLocation,
      targetLocation = _ref.targetLocation;
  var p = 0.017453292519943295; // Math.PI / 180

  var cos = Math.cos;
  var a = 0.5 - cos((targetLocation.lat - currentLocation.lat) * p) / 2 + cos(currentLocation.lat * p) * cos(targetLocation.lat * p) * (1 - cos((targetLocation.lng - currentLocation.lng) * p)) / 2;
  return 7917.6 * Math.asin(Math.sqrt(a)); // 2 * R; R = 3958.8 (radius of Earth in miles)
}; // @ts-ignore


exports.getDistance = getDistance;

var getNormalizedRegularHours = function getNormalizedRegularHours(_ref2) {
  var regular = _ref2.regular;
  return [].concat(_toConsumableArray(regular.slice(1)), [regular[0]]).reduce(function (result, _ref3) {
    var open = _ref3.open,
        close = _ref3.close,
        day = _ref3.day;
    var normalizedOpenDate = open.slice(0, 8);
    var normalizedCloseDate = close.slice(0, 8);

    var openTime = _luxon.DateTime.fromFormat(normalizedOpenDate.split('-')[0], 'hh:mm:ss', {
      locale: 'en-US'
    }).toLocaleString(_luxon.DateTime.TIME_SIMPLE);

    var closeTime = _luxon.DateTime.fromFormat(normalizedCloseDate.split('-')[0], 'hh:mm:ss', {
      locale: 'en-US'
    }).toLocaleString(_luxon.DateTime.TIME_SIMPLE);

    var hours = "".concat(openTime, " - ").concat(closeTime);
    result[hours] = result[hours] ? [].concat(_toConsumableArray(result[hours]), [day]) : [day];
    return result;
  }, {});
}; // use pattern in format '###-###-####'


exports.getNormalizedRegularHours = getNormalizedRegularHours;

var maskedString = function maskedString(value, pattern) {
  var i = 0;
  var restValue = value.slice(pattern.split('#').length - 1);
  return pattern.replace(/#/g, function (_) {
    return value[i++];
  }) + restValue;
};

exports.maskedString = maskedString;